import type { ReactNode } from 'react';
import { createStoreHooks } from '../core';
import { useViewportDimensions } from '../core/camera';
import { dom } from '../core/coordinate-system';
import { useCanvasEventHub } from '../core/feature-system';

const { useStore: useSelector } = createStoreHooks();

type CanvasRootProps = {
  children: ReactNode;
  className?: string;
};

export const CanvasRoot = ({ children, className }: CanvasRootProps) => {
  const canvas = useSelector(s => s.canvas);
  const {
    refs: { containerRef, viewportRef, canvasRef, contentRef, overlayRef },
    padding,
    transform,
  } = canvas;

  useViewportDimensions();
  useCanvasEventHub();

  return (
    <div
      ref={containerRef}
      style={{
        width: '100%',
        height: '100%',
        overflow: 'hidden',
        position: 'relative',
        overscrollBehavior: 'none',
        touchAction: 'pan-y pinch-zoom',
      }}
      className={className}
    >
      <svg
        ref={viewportRef}
        width="100%"
        height="100%"
        style={{
          display: 'block',
          userSelect: 'none',
          touchAction: 'none',
        }}
      >
        {/* Outer <g>: Applies zoom/pan transform (controlled by canvasTransform) */}
        <g ref={canvasRef} transform={dom.canvasTransform(transform)}>
          {/* Inner <g>: Applies padding offset (converted from screen pixels to canvas units) */}
          <g
            ref={contentRef}
            transform={dom.contentTransform(padding, transform)}
          >
            {children}
          </g>
        </g>
        {/* Overlay layer: Untransformed, in SVG viewport space */}
        <g ref={overlayRef} data-canvas-overlay>
          {/* Untransformed overlay layer */}
        </g>
      </svg>
    </div>
  );
};
